var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.item.first_name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.last_name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.position || '-')+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.email)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.item.phone || '-')+" ")]),_c('td',[(
        _vm.$userCheckAccess({
          abilities: 'edit_client_people',
        })
      )?_c('div',{staticClass:"buttons"},[_c('WorkClientPersonModal',{attrs:{"create":false,"id":_vm.item.id}}),_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-client']['persons-dialog-delete'][
            'udalit-kontakntoe-litso'
          ] +
          ' ' +
          _vm.item.first_name +
          ' ' +
          _vm.item.last_name}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }